module.exports = __webpack_public_path__ + "static/media/OpenSans-Semibold.31a82a9b.eot";